import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/login.vue'
import Dashboard from '../views/dashboard.vue'

/// Dashboard pages:
import DashboardView from '../views/dashboardView.vue'
import Insights from '../views/insights.vue'
import Facebook from '../views/facebook.vue'
import Twitter from '../views/twitter.vue'
import Linkedin from '../views/linkedin.vue'
import Youtube from '../views/youtube.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/dashboard' },
  { path: '*', redirect: '/dashboard' },
  // { path: '/', name: 'login', component: Login },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
    children: [
      {
        path: '/',
        name: 'view',
        component: DashboardView
      },
      {
        path: '/dashboard/fastinsights',
        name: 'fastinsights',
        component: Insights
      },
      {
        path: '/dashboard/facebook',
        name: 'facebook',
        component: Facebook
      },
      {
        path: '/dashboard/twitter',
        name: 'twitter',
        component: Twitter
      },
      {
        path: '/dashboard/linkedin',
        name: 'linkedin',
        component: Linkedin
      },
      {
        path: '/dashboard/youtube',
        name: 'youtube',
        component: Youtube
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
